import { useAuth } from "context/auth";
import getEsriData from "context/contextFunctions/getEsriData";
import { useEsriUrls } from "context/esriUrlsContext";
import { useMap } from "context/mapContext";
import { useState, useEffect } from "react";

function useGetAllZones() {
  const [esriUrls] = useEsriUrls();
  const [auth] = useAuth();
  const [zones, setZones] = useState(null);
  const [map] = useMap();
  const { view } = map;

  async function getZones() {
    const { res: zoneFeaturesAttributes } = await getEsriData({
      token: auth.esriToken,
      layerId: esriUrls.ZONING_DESC,
      layer: process.env.REACT_APP_PetraLayers_Table,
      featureOrMap: "MapServer",
      view,
    });
    setZones(zoneFeaturesAttributes);
  }
  useEffect(() => {
    (async () => {
      if (esriUrls.ZONING_DESC) await getZones();
    })();
  }, [esriUrls.ZONING_DESC, map]);

  return { zones };
}

export default useGetAllZones;
